export const currentPayment = (state) => state.currentPayment
export const payments = (state) => state.payments
export const paymentStatus = (state) => state.paymentStatus
